import React, {ReactElement} from "react";
import {Card, DescriptionCardHeading, DescriptionList, DescriptionListItemProps} from "peggirkit";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";

type Props = {
    title: string,
    description: string,
    noMargin?: boolean,
    children: ReactElement<DescriptionListItemProps> | ReactElement<DescriptionListItemProps>[],
};

const DescriptionListCard = ({title, description, noMargin = false, children}: Props) => {
    return (
        <Card
            containerClassname={noMargin ? "" : "mt-6 md:mt-10"}
            header={
                <CardHeader>
                    <DescriptionCardHeading
                        title={title}
                        description={description}
                    />
                </CardHeader>
            }
        >
            <DescriptionList
                compact={true}
                stacked={true}
                breakpoints={{
                    sm: {compact: false},
                    md: {stacked: false},
                }}
            >
                {children}
            </DescriptionList>
        </Card>
    );
};

export default DescriptionListCard;